module.exports = __webpack_public_path__ + "media/button-click.4a065a4f.mp3";